import { cx } from '@linaria/core';
import 'react';
import { AutoFocusInside } from 'react-focus-on';
import { makeKeyListener } from '@i-ark/utils';
import { button, colorCls, colorTransparencyAllowedCls, colorTransparencyDisallowedCls } from './Color.style.js';
import { jsx } from 'react/jsx-runtime';

const Color = ({
  allowTransparency,
  selected,
  color,
  borderColor,
  onPreview,
  onPreviewReset,
  onClick
}) => {
  const handlePreview = () => {
    if (onPreview !== undefined) {
      onPreview(color);
    }
  };
  const handlePreviewReset = () => {
    if (onPreviewReset !== undefined) {
      onPreviewReset();
    }
  };
  const handleClick = evt => {
    if (onClick !== undefined) {
      onClick(color);
    }
    evt.stopPropagation();
  };
  const handleKeyDown = makeKeyListener(["Enter", " "], evt => {
    handleClick(evt);
    evt.stopPropagation();
    evt.preventDefault();
  });
  return /*#__PURE__*/jsx("li", {
    className: cx(colorCls, allowTransparency && colorTransparencyAllowedCls, !allowTransparency && colorTransparencyDisallowedCls),
    style: {
      backgroundColor: color,
      borderColor: borderColor ?? color
    },
    children: /*#__PURE__*/jsx(AutoFocusInside, {
      className: button,
      disabled: !selected,
      children: /*#__PURE__*/jsx("button", {
        className: button,
        onMouseEnter: handlePreview,
        onMouseLeave: handlePreviewReset,
        onFocus: handlePreview,
        onBlur: handlePreviewReset,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        role: "option",
        "aria-selected": selected,
        "aria-label": "V\xE6lg denne farve"
      })
    })
  });
};

export { Color };
//# sourceMappingURL=Color.js.map
